import { useQuery } from "@tanstack/react-query";
import { ingestApi } from "../../../api";
import { SourceOrgCategory } from "../../../generated/ingest-api";

export function useListVersions(
  category: SourceOrgCategory,
  orgId: string,
  docId: string,
  enabled: boolean
) {
  return useQuery({
    queryKey: ["listDocumentVersions", category, orgId, docId],
    queryFn: () => ingestApi.listDocumentVersions(category, orgId, docId),
    enabled,
    refetchInterval: 10000,
  });
}
